module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, _vm._l((_vm.value), function(item, n) {
    return _c('div', {
      key: n,
      staticClass: "mb-1 d-flex"
    }, [_c('time-range-picker', {
      model: {
        value: (_vm.value[n]),
        callback: function($$v) {
          _vm.$set(_vm.value, n, $$v)
        },
        expression: "value[n]"
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "el-icon-delete",
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeHours(n)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addHours
    }
  }, [_vm._v("Add hours")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c7c394"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/TimeArrayPicker.vue
// module id = 378
// module chunks = 4